import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataBrokerService} from '../../../../core/services/data-broker/data-broker.service';
import {format} from 'date-fns';
import {CalendarEvent} from 'angular-calendar';
import {Appointment} from '../../../../core/models/appointment.model';
import {map, mergeMap} from 'rxjs/operators';
import {PerformerService} from '../../../../core/services/performer/performer.service';
import {DateUtility} from '../../../../core/utils/date-utility';
import {ImageService} from '../../../../core/services/image/image.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

interface DialogData {
  event: CalendarEvent;
  performerId: string;
}

@UntilDestroy()
@Component({
  selector: 'app-calendar-event-dialog',
  templateUrl: './calendar-event-dialog.component.html',
  styleUrls: ['./calendar-event-dialog.component.scss'],
})
export class CalendarEventDialogComponent implements OnInit {
  public labels: {[key: string]: string};
  public isLoaded = false;

  public appointment: Appointment;

  constructor(
    public dialogRef: MatDialogRef<CalendarEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dataBrokerService: DataBrokerService,
    private performerService: PerformerService,
    private dateUtil: DateUtility,
    private imageService: ImageService
  ) {
    const languageUpdate$ = this.dataBrokerService.subscribe('language-update');

    this.updateLanguage();
    languageUpdate$.pipe(untilDestroyed(this)).subscribe(this.updateLanguage.bind(this));
  }

  ngOnInit() {
    this.getPatientEvent();
  }

  private getPatientEvent() {
    this.performerService
      .getTasksByDay({performerId: this.data.performerId, date: this.start})
      .pipe(
        map((res) => res.find((task) => task.id === this.data.event.meta.id)),
        mergeMap((appointment) => this.imageService.addImage(appointment, 'patientImg', 100))
      )
      .subscribe((appointment: any) => {
        this.appointment = appointment;
        this.isLoaded = true;
      });
  }

  get start() {
    return this.dateUtil.formatDate(this.data.event.start, 'YYYY-MM-DD');
  }

  get title() {
    return this.data.event.title;
  }

  get time() {
    return format(this.data.event.start, 'hh:mm a');
  }

  onClose(): void {
    this.dialogRef.close();
  }

  private updateLanguage() {
    this.labels = {};
  }
}
